<template>
  <div class="component">
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div class="form-inline ml-3">
      <div class="form-group m-3">
        <label class="mr-2">Informação:</label>
        <select class="form-control" v-model="informationType">
          <option value="count" selected>Quantidade</option>
          <option value="investment">Soma de Investimentos</option>
          <option value="budget">Budget Liberado</option>
          <option value="purchase">Compra Realizada</option>
          <option value="status">Ações Executadas</option>
        </select>
      </div>
      <div class="form-group m-3">
        <label class="mr-2">Escolha um filtro:</label>
        <select class="form-control" v-model="filterType">
          <option value="general" selected>Geral</option>
          <option value="unit">Unidade</option>
          <option value="byMachine">Por Máquina</option>
        </select>
      </div>
      <div class="form-group m-3" v-if="filterType != 'general'">
        <label class="mr-2">Setores:</label>
        <select
            class="form-control"
            v-model="selectedSector"
            v-on:change="filterBySector()"
        >
          <option value="0" selected>Todos os Setores</option>
          <option v-for="sector in sectors" v-bind:key="sector" :value="sector">
            {{ sector }}
          </option>
        </select>
      </div>
      <div class="form-group m-3" v-if="filterType == 'byMachine'">
        <label class="mr-2">Máquinas:</label>
        <select
            class="form-control"
            v-model="selectedMachine"
            v-on:change="filterByMachine()"
            :disabled="selectedSector == '0'"
        >
          <option value="0" selected>Todas as Máquinas</option>
          <option
              v-for="machine in selectedMachines"
              v-bind:key="machine.id"
              :value="machine.id"
          >
            {{ machine.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <div class="container-fluid">
          <div
              class="card-info border-solid text-center big"
              style="
              border: 1px gainsboro solid;
              padding: 35px;
              border-radius: 10px;
            "
          >
            <div class="card-info-header">
              <h5>
                Avaliação De Risco
                <strong>Antes</strong> das Ações de Melhoria
              </h5>
            </div>
            <div>
              <b-table
                  hover
                  responsive
                  :items="tableCompanyHazardsDataBefore"
              ></b-table>
            </div>
            <div class="card-content">
              <pie-chart
                  v-if="pie_chart_data_loaded_before && hrnLevelsBeforeCount != 0 && hrnLevelsBeforeCount != '0,00'"
                  data-type="percentage"
                  :labels="pie.labels"
                  :colors="pie.colors"
                  :data="companyHazardsDataBefore"
                  :hazardData="companyHazardsBefore"
              ></pie-chart>
              <p
                  style="
                  font-size: large;
                  background: #d5d5d5;
                  border-radius: 8px;
                  padding: 5px;
                "
              >
                Total: {{ hrnLevelsBeforeCount }}
              </p>
              <div>
                <b-table
                    hover
                    responsive
                    :items="companyHazardsBeforeTable"
                >
                  <template #cell(Fatores)="data">
                    <span :title="data.item.Fatores">
                      <font-awesome-icon icon="eye" />
                    </span>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="container-fluid">
          <div
              class="card-info border-solid text-center big"
              style="
              border: 1px gainsboro solid;
              padding: 35px;
              border-radius: 10px;
            "
          >
            <div class="card-info-header">
              <h5>
                Avaliação De Risco
                <strong>Atual</strong>
              </h5>
            </div>
            <div>
              <b-table
                  hover
                  responsive
                  :items="tableCompanyHazardsDataCurrent"
              ></b-table>
            </div>
            <div class="card-content">
              <pie-chart
                  v-if="pie_chart_data_loaded_after && hrnLevelsCurrentCount != 0 && hrnLevelsCurrentCount != '0,00'"
                  data-type="percentage"
                  :labels="pie.labels"
                  :colors="pie.colors"
                  :data="companyHazardsDataCurrent"
                  :hazardData="companyHazardsBefore"
              ></pie-chart>
              <p
                  style="
                  font-size: large;
                  background: #d5d5d5;
                  border-radius: 8px;
                  padding: 5px;
                "
              >
                Total: {{ hrnLevelsCurrentCount }}
              </p>
              <b-table
                  hover
                  responsive
                  :items="companyHazardsBeforeTable"
              >
                <template #cell(Fatores)="data">
                    <span :title="data.item.Fatores">
                      <font-awesome-icon icon="eye" />
                    </span>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="container-fluid">
          <div
              class="card-info border-solid text-center big"
              style="
              border: 1px gainsboro solid;
              padding: 35px;
              border-radius: 10px;
            "
          >
            <div class="card-info-header">
              <h5>
                Avaliação De Risco
                <strong>Após</strong> as Ações de Melhoria
              </h5>
            </div>
            <div>
              <b-table
                  hover
                  responsive
                  :items="tableCompanyHazardsDataAfter"
              ></b-table>
            </div>
            <div class="card-content">
              <pie-chart
                  v-if="pie_chart_data_loaded_after && hrnLevelsAfterCount != 0 && hrnLevelsAfterCount != '0,00'"
                  data-type="percentage"
                  :labels="pie.labels"
                  :colors="pie.colors"
                  :data="companyHazardsDataAfter"
                  :hazardData="companyHazardsAfter"
              ></pie-chart>
              <p
                  style="
                  font-size: large;
                  background: #d5d5d5;
                  border-radius: 8px;
                  padding: 5px;
                "
              >
                Total: {{ hrnLevelsAfterCount }}
              </p>
              <b-table
                  hover
                  responsive
                  :items="companyHazardsAfterTable"
              >
                <template #cell(Fatores)="data">
                    <span :title="data.item.Fatores">
                      <font-awesome-icon icon="eye" />
                    </span>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row mt-3" v-if="hazards.length > 0">
      <div class="col-6">
        <div class="container-fluid">
          <div
            class="card-info border-solid text-center big"
            style="
              border: 1px gainsboro solid;
              padding: 35px;
              border-radius: 10px;
            "
          >
            <div class="card-info-header">
              <h5>Redução de Risco</h5>
            </div>
            <div>
              <b-table
                hover
                responsive
                :items="tableCompanyHazardReduction"
              ></b-table>
            </div>
            <div class="card-content">
              <bar-chart
                v-if="pie_chart_data_loaded_reduce"
                data-type="percentage"
                :labels="pie.labels"
                :colors="pie.colors"
                :data="companyHazardsReduction"
              ></bar-chart>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="row mt-3 p-3" v-if="filterType == 'byMachine'">
      <b-table
          :fields="fields"
          :items="hazards"
          v-if="showTableReduction"
          align="center"
      >
        <template v-slot:cell(description)="data" align="center">
          <div>{{ data.value }}</div>
        </template>
        <template v-slot:cell(initialRating)="data">
          <div>{{ data.value }}</div>
        </template>
        <template v-slot:cell(improvement_actions)="data">
          <div
              v-for="improvement_action in data.value"
              v-bind:key="improvement_action.id"
              style="word-wrap: break-word; max-width: 35vw"
          >
            <b>{{ improvement_action.name }}:</b>
            {{ improvement_action.description }}
          </div>
        </template>
        <template v-slot:cell(executed_actions)="data">
          <div
              v-for="improvement_action in data.item.improvement_actions"
              v-bind:key="improvement_action.id"
          >
            <div
                v-for="action_plan in improvement_action.action_plans"
                v-bind:key="action_plan.id"
                style="word-wrap: break-word; max-width: 30vw"
            >
              {{ action_plan.taken_action }}
            </div>
          </div>
        </template>
        <template v-slot:cell(improvementRating)="data">
          <div>{{ data.value }}</div>
        </template>
        <!-- <template slot="improvementRating" slot-scope="data">{{data.improvementRating}}</template> -->
        <!-- <template slot="count" slot-scope="data">
        <input class="form-control" type="text" v-model="data.item.count" />
        {{ data }}
        </template>-->
      </b-table>
    </div>
  </div>
</template>
<script>
import axios from "@/api/axios";
import PieChart from "@/components/charts/PieChart.vue";
// import BarChart from "@/components/charts/BarChart.vue";
import moment from "moment";

export default {
  name: "list-groups",
  props: {
    company_id: String,
  },
  components: {
    PieChart,
    // BarChart,
  },
  data() {
    return {
      perPage: 8,
      currentPage: 1,
      rows: 4,
      data: [],
      items: [
        {
          text: "Documentos",
          href: "#/admin/Documents/Index",
        },
        {
          text: "",
          href: "#",
        },
        {
          text: "Plano de Gestão de Riscos",
          href: "#",
          active: true,
        },
      ],
      fields: [
        {key: "name", label: "Risco", thClass: "tableHeader"},
        {
          key: "description",
          label: "Descrição",
          tdClass: "longText",
          thClass: "tableHeader",
        },
        {
          key: "initialRating",
          label: "Avaliação Inicial do Risco",
          tdClass: "getCellColor",
          thClass: "tableHeader",
        },
        {
          key: "improvement_actions",
          label: "Ações Propostas APR",
          thClass: "tableHeader",
          tdClass: "longText",
        },
        {
          key: "executed_actions",
          label: "Ações Executadas",
          thClass: "tableHeader",
        },
        // { key: "improvement_actions", label: "Ações Executadas" },
        {
          key: "improvementRating",
          label: "Avaliação de Risco com as Ações",
          tdClass: "getCellColor",
          thClass: "tableHeader",
        },
        // { key: "id", label: "Responsável" },
        // { key: "id", label: "Status Ações" }
      ],
      role: localStorage.getItem("auth.role"),
      companyHazardsBefore: [],
      companyHazardsAfter: [],
      companyHazardsDataBefore: [],
      companyHazardsDataAfter: [],
      // companyHazardsReduction: [],
      hazards: [],
      hazardsFinished: [],
      hrnLevelsBefore: [],
      hrnLevelsCurrent: [],
      hrnLevelsAfter: [],
      hrnLevelsBeforeCount: 0,
      hrnLevelsCurrentCount: 0,
      hrnLevelsAfterCount: 0,
      selectedMachines: [],
      pie_chart_data_loaded_after: false,
      pie_chart_data_loaded_before: false,
      // pie_chart_data_loaded_reduce: false,
      showTableReduction: false,
      pie: {
        labels: [
          "Aceitável",
          "Baixo",
          "Moderado",
          "Significativo",
          "Alto",
          "Muito Alto",
          "Extremo",
        ],
        colors: [
          "#92d050",
          "#00b0f0",
          "#ffff00",
          "#ffc000",
          "#e36c0a",
          "#ff0000",
          "#000000",
        ],
      },
      companyHazardsBeforeTable: [],
      companyHazardsAfterTable: [],
      tableCompanyHazardsDataBefore: [],
      tableCompanyHazardsDataCurrent: [],
      tableCompanyHazardsDataAfter: [],
      // tableCompanyHazardReduction: [],
      selectedSector: "0",
      selectedMachine: "0",
      filterType: "general",
      informationType: "count",
      sectors: [],
      company: {},
    };
  },
  mounted() {
    this.cleanArrays();
    this.getCompanyHazards();
    // localStorage.setItem("company_id", this.company_id);
    this.getCompany(this.company_id);
  },
  methods: {
    formatDate: function (date) {
      return moment(date).format("DD/MM/YYYY hh:mm");
    },
    getCellColor: function (value) {
      switch (value) {
        case "Aceitável":
          return ["aceitavel ratingCell"];
        case "Baixo":
          return ["baixo", "ratingCell"];
        case "Moderado":
          return ["moderado", "ratingCell"];
        case "Significativo":
          return ["significativo", "ratingCell"];
        case "Alto":
          return ["alto", "ratingCell"];
        case "Muito Alto":
          return ["muito-alto", "ratingCell"];
        case "Extremo":
          return ["extremo", "ratingCell"];
      }
    },
    cleanArrays: function () {
      this.companyHazardsDataBefore = [];
      this.companyHazardsDataCurrent = [];
      this.companyHazardsDataAfter = [];
      this.tableCompanyHazardsDataBefore = [];
      this.tableCompanyHazardsDataCurrent = [];
      this.tableCompanyHazardsDataAfter = [];
      // this.tableCompanyHazardReduction = [];
      this.hrnLevelsBefore = [];
      this.hrnLevelsCurrent = [];
      this.hrnLevelsAfter = [];
      this.hrnLevelsBeforeCount = 0;
      this.hrnLevelsCurrentCount = 0;
      this.hrnLevelsAfterCount = 0;
    },
    getCompany: function (company_id) {
      axios
          .get(
              `${process.env.VUE_APP_API_HOST}/api/admin/companies/${company_id}?include=corporate-group`
          )
          .then((response) => {
            this.company = response.data.data;
            this.items[1].text = this.company.corporate_name;
            this.items[1].href = `#/admin/Documents/Company/${this.company.id}`;
            this.selectedMachines = this.company.machines;
            this.company.machines.forEach((machine) => {
              if (!this.sectors.find((sector) => sector == machine.sector)) {
                this.sectors.push(machine.sector);
              }
            });
            this.sectors.sort();
            this.company.machines.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
          });
    },
    filterBySector: function () {
      this.cleanArrays();
      if (this.selectedSector != "0") {
        this.selectedMachines = this.company.machines;
        this.selectedMachines = this.selectedMachines.filter(
            (machine) => machine.sector == this.selectedSector
        );
        axios
            .post(
                `${process.env.VUE_APP_API_HOST}/api/admin/get-hazards-by-sector/${this.company_id}`,
                {sector: this.selectedSector}
            )
            .then((response) => {
              this.hazards = response.data;
              if (this.hazards.length > 0) {
                this.getChartsTablesData();
              }
            });
      } else {
        this.getUnitHazards();
      }
    },
    filterByMachine: function () {
      this.cleanArrays();
      if (this.selectedMachine != "0") {
        axios
            .post(
                `${process.env.VUE_APP_API_HOST}/api/admin/get-hazards-by-machine/${this.company_id}`,
                {machine_id: this.selectedMachine}
            )
            .then((response) => {
              this.hazards = response.data;
              if (this.hazards.length > 0) {
                this.getChartsTablesData();
              }
            });
      } else {
        this.filterBySector();
      }
    },

    getCompanyHazards() {
      this.cleanArrays();
      axios
          .get(
              `${process.env.VUE_APP_API_HOST}/api/admin/corporate-group-hazards/${this.company_id}`
          )
          .then((response) => {
            this.hazards = response.data;
            this.hazards.forEach((hazard) => {
              let finished = true;
              hazard.improvement_actions.forEach((improvement_action) => {
                improvement_action.action_plans.forEach((action_plan) => {
                  if (action_plan.status == "Pendente") {
                    finished = false;
                  }
                });
              });
              if (finished) {
                this.hazardsFinished.push(hazard);
              }
            });

            if (this.hazards.length > 0) {
              this.getChartsTablesData();
            }
          });
    },

    getUnitHazards() {
      // this.showTableReduction = false;
      this.cleanArrays();
      axios
          .get(
              `${process.env.VUE_APP_API_HOST}/api/admin/company-hazards/${this.company_id}`
          )
          .then((response) => {
            this.hazards = response.data;
            this.hazards.forEach((hazard) => {
              let finished = true;
              hazard.improvement_actions.forEach((improvement_action) => {
                improvement_action.action_plans.forEach((action_plan) => {
                  if (action_plan.status == "Pendente") {
                    finished = false;
                  }
                });
              });
              if (finished) {
                this.hazardsFinished.push(hazard);
              }
            });

            if (this.hazards.length > 0) {
              this.getChartsTablesData();
            }
          });
    },

    getChartsTablesData() {
      this.pie_chart_data_loaded_before = false;
      // console.log(this.pie_chart_data_loaded_before);
      this.pie_chart_data_loaded_after = false;
      // this.pie_chart_data_loaded_reduce = false;
      this.showTableReduction = false;

      let hrns = [];
      this.hazards.forEach((hazard) => {
        hrns.push(
            this.calculateHRN(
                hazard.score_np,
                hazard.score_dph,
                hazard.score_fe,
                hazard.score_lo
            )
        );
      });

      hrns.forEach((result) => {
        this.hrnLevelsBefore.push(result.hrnLevel);
      });
      for (let i = 0; i < this.hazards.length; i++) {
        this.hazards[i].initialRating = this.hrnLevelsBefore[i];
      }

      this.getChartData(this.companyHazardsDataBefore, this.hrnLevelsBefore);
      this.tableCompanyHazardsDataBefore = this.getTableData(
          this.companyHazardsDataBefore,
          this.hrnLevelsBefore,
          "Before"
      );

      this.companyHazardsBeforeTable = this.getTableDataAnalysisBefore();

      let hrns2 = [];

      this.hazards.forEach((hazard) => {
        hrns2.push(
            this.calculateHRN(
                hazard.improvement_score_np,
                hazard.improvement_score_dph,
                hazard.improvement_score_fe,
                hazard.improvement_score_lo
            )
        );
      });

      this.showTableReduction = false;
      this.pie_chart_data_loaded_after = false;
      hrns2.forEach((result) => {
        this.hrnLevelsAfter.push(result.hrnLevel);
      });

      for (let i = 0; i < this.hazards.length; i++) {
        this.hazards[i].improvementRating = this.hrnLevelsAfter[i];

        if (this.hazardsFinished.find((el) => el.id == this.hazards[i].id)) {
          this.hrnLevelsCurrent.push(this.hrnLevelsAfter[i]);
        } else {
          this.hrnLevelsCurrent.push(this.hrnLevelsBefore[i]);
        }
      }


      this.getChartData(this.companyHazardsDataAfter, this.hrnLevelsAfter);
      this.getChartData(
          this.companyHazardsDataCurrent,
          this.hrnLevelsCurrent
      );

      this.tableCompanyHazardsDataAfter = this.getTableData(
          this.companyHazardsDataAfter,
          this.hrnLevelsAfter,
          "After"
      );
      this.companyHazardsAfterTable = this.getTableDataAnalysisAfter();

      this.tableCompanyHazardsDataCurrent = this.getTableData(
          this.companyHazardsDataCurrent,
          this.hrnLevelsCurrent,
          "Current"
      );

      // this.tableCompanyHazardReduction = this.getTableDataPercentage(
      //   this.calculateHazardReduction()
      // );

      // this.companyHazardsReduction = this.calculateHazardReduction();
      this.$nextTick(() => {
        this.pie_chart_data_loaded_before = true;
        this.pie_chart_data_loaded_after = true;
      })

      // this.pie_chart_data_loaded_reduce = true;
      this.showTableReduction = false;
      this.showTableReduction = true;

    },
    // calculateHazardReduction: function () {
    //   let tableDataReduction = [];
    //   tableDataReduction.push(
    //     (
    //       this.tableCompanyHazardsDataBefore[1]["Aceitável"].replace("%", "") -
    //       this.tableCompanyHazardsDataAfter[1]["Aceitável"].replace("%", "")
    //     ).toFixed(2)
    //   );

    //   tableDataReduction.push(
    //     (
    //       this.tableCompanyHazardsDataBefore[1]["Baixo"].replace("%", "") -
    //       this.tableCompanyHazardsDataAfter[1]["Baixo"].replace("%", "")
    //     ).toFixed(2)
    //   );
    //   tableDataReduction.push(
    //     (
    //       this.tableCompanyHazardsDataBefore[1]["Moderado"].replace("%", "") -
    //       this.tableCompanyHazardsDataAfter[1]["Moderado"].replace("%", "")
    //     ).toFixed(2)
    //   );
    //   tableDataReduction.push(
    //     (
    //       this.tableCompanyHazardsDataBefore[1]["Significativo"].replace(
    //         "%",
    //         ""
    //       ) -
    //       this.tableCompanyHazardsDataAfter[1]["Significativo"].replace("%", "")
    //     ).toFixed(2)
    //   );
    //   tableDataReduction.push(
    //     (
    //       this.tableCompanyHazardsDataBefore[1]["Alto"].replace("%", "") -
    //       this.tableCompanyHazardsDataAfter[1]["Alto"].replace("%", "")
    //     ).toFixed(2)
    //   );
    //   tableDataReduction.push(
    //     (
    //       this.tableCompanyHazardsDataBefore[1]["Muito Alto"].replace("%", "") -
    //       this.tableCompanyHazardsDataAfter[1]["Muito Alto"].replace("%", "")
    //     ).toFixed(2)
    //   );
    //   tableDataReduction.push(
    //     (
    //       this.tableCompanyHazardsDataBefore[1]["Extremo"].replace("%", "") -
    //       this.tableCompanyHazardsDataAfter[1]["Extremo"].replace("%", "")
    //     ).toFixed(2)
    //   );
    //   return tableDataReduction;
    // },
    calculateHRN: function (np, dph, fe, lo) {
      // let promise = axios.post(
      //   `${process.env.VUE_APP_API_HOST}/api/admin/calculate-hrn/`,
      //   {
      //     np: np,
      //     dph: dph,
      //     fe: fe,
      //     lo: lo,
      //   }
      // );
      // return promise;

      let calculatedHrn = np * dph * fe * lo;
      let hrnLevel = "";

      if (calculatedHrn < 5)
        hrnLevel = "Aceitável";
      else if (calculatedHrn < 25)
        hrnLevel = "Baixo";
      else if (calculatedHrn < 50)
        hrnLevel = "Moderado";
      else if (calculatedHrn < 100)
        hrnLevel = "Significativo";
      else if (calculatedHrn < 200)
        hrnLevel = "Alto";
      else if (calculatedHrn < 500)
        hrnLevel = "Muito Alto";
      else
        hrnLevel = "Extremo";

      return {hrn: Math.round((calculatedHrn + Number.EPSILON) * 10000) / 10000, hrnLevel: hrnLevel};
    },
    getChartData: function (data, hrnArray) {
      let total = hrnArray.length;
      data[0] = (
          (this.getHazardCount("Aceitável", hrnArray) * 100) /
          total
      ).toFixed(2);
      data[1] = (
          (this.getHazardCount("Baixo", hrnArray) * 100) /
          total
      ).toFixed(2);
      data[2] = (
          (this.getHazardCount("Moderado", hrnArray) * 100) /
          total
      ).toFixed(2);
      data[3] = (
          (this.getHazardCount("Significativo", hrnArray) * 100) /
          total
      ).toFixed(2);
      data[4] = ((this.getHazardCount("Alto", hrnArray) * 100) / total).toFixed(
          2
      );
      data[5] = (
          (this.getHazardCount("Muito Alto", hrnArray) * 100) /
          total
      ).toFixed(2);
      data[6] = (
          (this.getHazardCount("Extremo", hrnArray) * 100) /
          total
      ).toFixed(2);
    },
    getTableDataAnalysisBefore: function () {
      let rows = [];
      Object.keys(this.companyHazardsBefore).forEach((hazard) => {
        if (this.companyHazardsBefore[hazard].length > 0) {
          this.companyHazardsBefore[hazard].forEach((nivel) => {
            rows.push({
              Nível: hazard,
              Fatores: nivel.hazard_analysis.factors,
              Máquina: nivel.hazard_analysis.machine.name,
              Código: nivel.hazard_analysis.number_code,
            });
          });
        }
      });

      return rows;
    },
    getTableDataAnalysisAfter: function () {
      console.log(this.companyHazardsAfter);
      let rows = [];

      Object.keys(this.companyHazardsAfter).forEach((hazard) => {
        if (this.companyHazardsAfter[hazard].length > 0) {
          this.companyHazardsAfter[hazard].forEach((nivel) => {
            rows.push({
              Nível: hazard,
              Fatores: nivel.hazard_analysis.factors,
              Máquina: nivel.hazard_analysis.machine.name,
              Código: nivel.hazard_analysis.number_code,
            });
          });
        }
      });

      return rows;
    },
    getTableData: function (data, hrnArray, type) {
      let valuesRow = {
        Aceitável: this.getHazardValue("Aceitável", hrnArray),
        Baixo: this.getHazardValue("Baixo", hrnArray),
        Moderado: this.getHazardValue("Moderado", hrnArray),
        Significativo: this.getHazardValue("Significativo", hrnArray),
        Alto: this.getHazardValue("Alto", hrnArray),
        "Muito Alto": this.getHazardValue("Muito Alto", hrnArray),
        Extremo: this.getHazardValue("Extremo", hrnArray),
      };

      let totalValues = Object.values(valuesRow).reduce((a, b) => a + b);
      let acceptable = (totalValues == 0 ? 0 : 100 * valuesRow["Aceitável"] / totalValues).toFixed(2);
      let low = (totalValues == 0 ? 0 : 100 * valuesRow["Baixo"] / totalValues).toFixed(2);
      let moderate = (totalValues == 0 ? 0 : 100 * valuesRow["Moderado"] / totalValues).toFixed(2);
      let significative = (totalValues == 0 ? 0 : 100 * valuesRow["Significativo"] / totalValues).toFixed(2);
      let high = (totalValues == 0 ? 0 : 100 * valuesRow["Alto"] / totalValues).toFixed(2);
      let veryHigh = (totalValues == 0 ? 0 : 100 * valuesRow["Muito Alto"] / totalValues).toFixed(2);
      let extreme = (totalValues == 0 ? 0 : 100 * valuesRow["Extremo"] / totalValues).toFixed(2);

      let percentagesRow = {
        Aceitável: acceptable + "%",
        Baixo: low + "%",
        Moderado: moderate + "%",
        Significativo: significative + "%",
        Alto: high + "%",
        "Muito Alto": veryHigh + "%",
        Extremo: extreme + "%",
      }

      if (type == "Before") {
        this.updateCompanyHazardsPerLevel('before', percentagesRow);
        this.companyHazardsDataBefore = [acceptable, low, moderate, significative, high, veryHigh, extreme];
        this.hrnLevelsBeforeCount = this.informationType != "investment" ? totalValues : 'R$ ' + totalValues.toLocaleString('pt-Br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      } else if (type == "Current") {
        this.updateCompanyHazardsPerLevel('current', percentagesRow);
        this.companyHazardsDataCurrent = [acceptable, low, moderate, significative, high, veryHigh, extreme];
        this.hrnLevelsCurrentCount = this.informationType != "investment" ? totalValues : 'R$ ' + totalValues.toLocaleString('pt-Br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      } else if (type == "After") {
        this.updateCompanyHazardsPerLevel('after', percentagesRow);
        this.companyHazardsDataAfter = [acceptable, low, moderate, significative, high, veryHigh, extreme];
        this.hrnLevelsAfterCount = this.informationType != "investment" ? totalValues : 'R$ ' + totalValues.toLocaleString('pt-Br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }

      if (this.informationType == "investment") {
        Object.keys(valuesRow).map(function (key) {
          valuesRow[key] = 'R$ ' + valuesRow[key].toLocaleString('pt-Br', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
        });
      }

      return [valuesRow, percentagesRow];
    },
    updateCompanyHazardsPerLevel(phase, percentagesRow) {
      let hazards = [];
      Object.keys(percentagesRow).forEach((level) => {
        hazards[level] = [];
        this.hazards.forEach((hazard) => {
          if (phase === 'after') {
            if (hazard.improvementRating === level) {
              hazards[level].push(hazard);
            }
          } else {
            if (hazard.initialRating === level) {
              hazards[level].push(hazard);
            }
          }
        });
      });
      if (phase === 'after') {
        this.companyHazardsAfter = hazards;
      } else {
        this.companyHazardsBefore = hazards;
      }
    },
    getHazardValue(level, hrnArray) {
      switch (this.informationType) {
        case "count":
          return this.getHazardCount(level, hrnArray);
        case "investment":
          return this.getHazardInvestment(level, hrnArray);
        case "budget":
          return this.getHazardBudgetCount(level, hrnArray);
        case "purchase":
          return this.getHazardPurchaseCount(level, hrnArray);
        case "status":
          return this.getHazardStatusCount(level, hrnArray);
      }
    },
    getHazardCount: function (name, hrnArray) {
      return hrnArray.filter((level) => level == name).length;
    },
    getHazardInvestment: function (name, hrnArray) {
      let investments = [];
      for (let i = 0; i < this.hazards.length; i++) {
        if (hrnArray[i] == name && this.hazards[i].improvement_actions) {
          this.hazards[i].improvement_actions.forEach((improvementAction) => {
            if (improvementAction.action_plans) {
              improvementAction.action_plans.forEach((actionPlan) => {
                let investment = parseFloat(actionPlan.investment_amount);
                if (!isNaN(investment)) {
                  investments.push(investment);
                }
              });
            }
          });
        }
      }
      let sum = investments.length > 0 ? investments.reduce((acc, val) => acc + val) : 0;
      return sum;
    },
    getHazardBudgetCount: function (name, hrnArray) {
      let count = 0;
      for (let i = 0; i < this.hazards.length; i++) {
        if (hrnArray[i] == name && this.hazards[i].improvement_actions) {
          this.hazards[i].improvement_actions.forEach((improvementAction) => {
            if (improvementAction.action_plans) {
              improvementAction.action_plans.forEach((actionPlan) => {
                if (actionPlan.is_budged_released) {
                  count++;
                }
              });
            }
          });
        }
      }
      return count;
    },
    getHazardPurchaseCount: function (name, hrnArray) {
      let count = 0;
      for (let i = 0; i < this.hazards.length; i++) {
        if (hrnArray[i] == name && this.hazards[i].improvement_actions) {
          this.hazards[i].improvement_actions.forEach((improvementAction) => {
            if (improvementAction.action_plans) {
              improvementAction.action_plans.forEach((actionPlan) => {
                if (actionPlan.is_purchase_realised) {
                  count++;
                }
              });
            }
          });
        }
      }
      return count;
    },
    getHazardStatusCount: function (name, hrnArray) {
      let count = 0;
      for (let i = 0; i < this.hazards.length; i++) {
        if (hrnArray[i] == name && this.hazards[i].improvement_actions) {
          this.hazards[i].improvement_actions.forEach((improvementAction) => {
            if (improvementAction.action_plans) {
              improvementAction.action_plans.forEach((actionPlan) => {
                if (actionPlan.status == "Executada") {
                  count++;
                }
              });
            }
          });
        }
      }
      return count;
    },
    // getTableDataPercentage: function (data) {
    //   return [
    //     {
    //       Aceitável: data[0] + "%",
    //       Baixo: data[1] + "%",
    //       Moderado: data[2] + "%",
    //       Significativo: data[3] + "%",
    //       Alto: data[4] + "%",
    //       "Muito Alto": data[5] + "%",
    //       Extremo: data[6] + "%",
    //     },
    //   ];
    // },
  },

  watch: {
    filterType() {
      this.selectedSector = "0";
      this.selectedMachine = "0";

      if (this.filterType == 'general') {
        this.getCompanyHazards();
      } else {
        this.getUnitHazards();
      }
    },
    informationType() {
      if (this.filterType == 'general') {
        this.getCompanyHazards();
      } else if (this.selectedMachine != "0") {
        this.filterByMachine();
      } else if (this.selectedSector != "0") {
        this.filterBySector();
      } else {
        this.getUnitHazards();
      }
    }
  },
};
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap";
@import "node_modules/bootstrap-vue/src/index.scss";
@import "src/styles/General.scss";
@import "src/styles/HazardManagementPlan.scss";
</style>
